import { OTHERS, PUBLISH_STATUS } from '../common/commonConstant';
import CustomSweetAlert from '../common/customSweetAlert/CustomSweetAlert';
import { getFoodDetail, getProductCategories, getProducts, toggleFavouriteFood } from '../services/healthWellness/foodCalories.service';
import { GET_FOOD_CATEGORIES, GET_FOOD_DETAIL, GET_FOOD_PRODUCTS, RESET_FOOD_PRODUCTS, TOGGLE_FAVOURITE_FOOD } from './types';

export const fetchFoodCategories = () => (dispatch) => getProductCategories()
  .then((rest) => {
    dispatch({
      type: GET_FOOD_CATEGORIES,
      payload: rest,
    });
    return rest;
  })
  .catch(function (error) {
    CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
  });

export const fetchFoodProducts = ({ categoryId, type, pageOffset, pageNo }) =>
  (dispatch) => getProducts(
    {
      ...['', 'all'].includes(categoryId) ? {} : { categoryId },
      ...[OTHERS].includes(categoryId) ? { categoryType: OTHERS, categoryId: null } : {},
      type,
      limit: pageOffset || 100,
      start: pageNo,
      status: PUBLISH_STATUS.PUBLISHED,
    })
    .then((rest) => {
      dispatch({
        type: GET_FOOD_PRODUCTS,
        payload: rest,
        productType: type.toLowerCase(),
        categoryId,
      });
      return rest;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const getFoodDetails = (params) => (dispatch) =>
  getFoodDetail(params)
    .then((result) => {
      dispatch({
        type: GET_FOOD_DETAIL,
        payload: result,
      });
      return result;
    }).catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const toggleFavourite = (foodDetail) => (dispatch) =>
  toggleFavouriteFood(foodDetail)
    .then((result) => {
      dispatch({
        type: TOGGLE_FAVOURITE_FOOD,
        payload: ({ isFavourite: foodDetail.isFavourite, favouriteProductId: foodDetail.isFavourite ? foodDetail.favouriteProductId : null, productCategory: '' }),
      });
      return result;
    })
    .catch((error) => {
      CustomSweetAlert({
        title: "",
        text: "failed to change favourite state",
        confirmButtonText: "ตกลง",
      });
      throw new Error(error);
    })


export const resetFoodProducts = () => dispatch => {
  dispatch({ type: RESET_FOOD_PRODUCTS })
}
